
export default function FeaturesSection() {
  const features = [
    {
      icon: "ri-user-star-line",
      title: "Expert Native Tutors",
      description: "Learn from certified native English speakers with years of teaching experience and proven track records."
    },
    {
      icon: "ri-calendar-schedule-line",
      title: "Flexible Scheduling",
      description: "Book lessons at your convenience with 24/7 availability. Perfect for busy professionals and students."
    },
    {
      icon: "ri-smartphone-line",
      title: "Mobile Learning",
      description: "Access your lessons anywhere with our mobile-friendly platform. Learn on-the-go with offline capabilities."
    },
    {
      icon: "ri-user-line",
      title: "Personalized Learning",
      description: "Customized lesson plans tailored to your goals, learning style, and current English proficiency level."
    },
    {
      icon: "ri-chat-3-line",
      title: "Interactive Lessons",
      description: "Engage with multimedia content, interactive exercises, and real-time feedback to accelerate your progress."
    },
    {
      icon: "ri-trophy-line",
      title: "Progress Tracking",
      description: "Monitor your improvement with detailed analytics, achievement badges, and milestone celebrations."
    },
    {
      icon: "ri-group-line",
      title: "Community Support",
      description: "Join study groups, practice with peers, and participate in English conversation clubs worldwide."
    },
    {
      icon: "ri-shield-check-line",
      title: "Money-Back Guarantee",
      description: "We're confident in our teaching methods. If you're not satisfied, get a full refund within 30 days."
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose Our English Learning Platform?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience the most effective way to learn English with our innovative teaching methods and comprehensive support system.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center group hover:transform hover:scale-105 transition-all duration-300">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-600 transition-colors duration-300">
                <i className={`${feature.icon} text-2xl text-blue-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Start Your English Journey Today
              </h3>
              <p className="text-gray-600 mb-6">
                Join thousands of successful students who have transformed their English skills with our proven learning system. 
                Get started with a free trial lesson and experience the difference.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-play-circle-line mr-2"></i>
                  Start Free Trial
                </button>
                <button className="border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-phone-line mr-2"></i>
                  Schedule Call
                </button>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/c480aa45edc411b0a789f171dd16837a.jpg"
                alt="Students celebrating English learning success"
                className="w-full h-64 object-cover object-top rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
